const actions = {
  /**
   * Sets window scroll top value
   * @param {Number} scrollTop - The scroll top position of the window
   * @returns {Object} an event object with a payload
   */
  setScrollTop(scrollTop) {
    return {
      type: 'SCROLL_TOP_CHANGED',
      scrollTop,
    };
  },
};

export default actions;



/** WEBPACK FOOTER **
 ** ./assets/js/src/actions/large-card-actions.js
 **/